import actionTypes from 'actionTypes';
import { TENANT_UTILS } from 'utils/tenants';

export function setSecondaryHeader(payload) {
  return {
    type: actionTypes.SET_SECONDARY_HEADER,
    payload,
  };
}

export function setBackendErrorMessage(errorMessage) {
  return {
    type: actionTypes.SET_BACKEND_ERROR_MESSAGE,
    errorMessage: errorMessage,
  };
}

export function setCurrentTenant(payload) {
  TENANT_UTILS.setTenantInCache(payload);
  return (dispatch) => {
    return dispatch({ type: actionTypes.SET_CURRENT_TENANT, payload });
  };
}
